import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  failed: boolean;
}

// Catches lazy-route chunk load/render failures. After a redeploy, a returning
// visitor's app may try to fetch a code-split chunk whose hashed filename no
// longer exists, which throws during render. Rather than leave a blank screen,
// trigger the same one-time cache-busting reload used for the initial bundle
// (window.__esgHeal, defined inline in index.html).
export class RouteErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch() {
    const heal = (window as unknown as { __esgHeal?: () => void }).__esgHeal;
    if (typeof heal === "function") heal();
  }

  render() {
    if (this.state.failed) return null;
    return this.props.children;
  }
}
